import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import { media, colors, animation } from '../styles/constants';

const { shortAnimationDuration, transitionTimingFn } = animation;

const RippleDiv = styled.div`
  position: absolute;
  top: 4.4rem;
  right: 4rem;
  background: ${colors.cyan};
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  z-index: -1;
  opacity: 0;

  @media (min-width: ${media.tabletPortrait}) {
    display: none;
  }

  &.ripple-appear-active,
  &.ripple-enter-active {
    opacity: 0;
    transform: scale(1);
  }

  &.ripple-enter-done {
    transform: scale(250);
    opacity: 1;
    transition-property: transform, opacity;
    transition-duration: ${shortAnimationDuration}ms;
    transition-timing-function: ${transitionTimingFn};
  }

  &.ripple-exit {
    transform: scale(250);
    opacity: 1;
  }

  &.ripple-exit-done {
    opacity: 0;
    transform: scale(1);
    will-change: transform, opacity;
    transition-property: transform, opacity;
    transition-duration: ${shortAnimationDuration}ms;
    transition-timing-function: ${transitionTimingFn};
  }
`;

const Ripple = ({ isMenuOpen }) => (
  <CSSTransition
    classNames="ripple"
    timeout={shortAnimationDuration}
    in={isMenuOpen}
    appear
  >
    <RippleDiv />
  </CSSTransition>
);

Ripple.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired
};

export default Ripple;
